<template>
  <vs-popup title="Agregar Documento" :active.sync="popupActive">
    <div class="p-8">
      <p class="mb-6 text-grey text-center">Sube un documento PDF para firmar. Tamaño máximo: 20 MB.</p>
      
      <div 
        class="flex flex-col items-center justify-center border-2 border-dashed border-gray-400 rounded-xl p-12 cursor-pointer hover:bg-gray-100 hover:border-primary transition-all duration-300 ease-in-out bg-gray-50 mb-8"
        :class="{'border-primary bg-primary-light': selectedFile}"
        @click="triggerFileInput"
        @dragover.prevent
        @drop.prevent="handleDrop"
      >
        <feather-icon 
            :icon="selectedFile ? 'CheckCircleIcon' : 'FileTextIcon'" 
            :svgClasses="['w-16 h-16 mb-4 transition-colors', selectedFile ? 'text-primary' : 'text-grey']" 
        />
        <div v-if="!selectedFile" class="text-center">
            <h5 class="mb-1">Haz clic o arrastra un archivo PDF aquí</h5>
            <p class="text-grey text-sm">El archivo será procesado para firma</p>
        </div>
        <div v-else class="text-center">
            <h5 class="text-primary font-bold mb-1">{{ selectedFile.name }}</h5>
            <p class="text-grey text-sm font-medium">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</p>
        </div>
        <input type="file" ref="fileInput" class="hidden" accept=".pdf" @change="handleFileSelection">
      </div>

      <div class="flex justify-end gap-4 mt-4">
          <vs-button type="border" color="danger" class="px-8" @click="closePopup">Cancelar</vs-button>
          <vs-button @click="submitUpload" :disabled="!selectedFile" class="px-8 shadow-md">Agregar documento</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { isPdfA, PDFA_NOT_SUPPORTED_MESSAGE } from "@/_helpers";

export default {
  name: 'UploadSingleDocument',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    container: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedFile: null
    }
  },
  computed: {
    popupActive: {
      get() {
        return this.active
      },
      set(val) {
        if (!val) {
          this.closePopup()
        }
      }
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileSelection(event) {
      const file = event.target.files[0]
      this.validateAndSetFile(file)
    },
    handleDrop(event) {
      const file = event.dataTransfer.files[0]
      this.validateAndSetFile(file)
    },
    async validateAndSetFile(file) {
      if (file) {
        // Validate MIME type or extension
        if (file.type !== "application/pdf" && !file.name.endsWith('.pdf')) {
            this.$store.dispatch('alert/error', 'Por favor selecciona un archivo PDF.')
            return;
        }

        // Validate Size (20MB = 20 * 1024 * 1024 bytes)
        const maxSize = 20 * 1024 * 1024;
        if (file.size > maxSize) {
            this.$store.dispatch('alert/error', 'El documento no debe superar los 20mb de peso permitido')
            return;
        }

        if (await isPdfA(file)) {
            this.$store.dispatch('alert/error', PDFA_NOT_SUPPORTED_MESSAGE)
            this.$refs.fileInput.value = null
            return;
        }

        this.selectedFile = file
      }
    },
    submitUpload() {
      if (!this.selectedFile) return;

      this.$vs.loading()
      
      this.$store.dispatch("containerManagement/addDocument", {
          uuid: this.container.uuid,
          file: this.selectedFile
      })
      .then(() => {
        this.$vs.loading.close()
        this.$store.dispatch('alert/success', 'Documento agregado correctamente.')
        this.selectedFile = null
        this.$emit('upload-success')
        this.closePopup()
      })
      .catch(error => {
          this.$vs.loading.close()
          this.$store.dispatch('alert/error', error || 'Error al subir el documento.')
      });
    },
    closePopup() {
      this.selectedFile = null
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";

.bg-primary-light {
  background-color: rgba($primary, 0.05) !important;
}

.upload-area {
  &:hover {
    border-color: $primary !important;
  }
}
</style>

